export default "/_next/static/chunks/fonts/Montserrat-ExtraLight-latin-fd78d0476e2ce3fd9193d047de955729.woff2";